import {getRestApi} from './ApiAxios'

export const ObtenerEmpresasUsuarioB2c = async (guid) => {
  const restApi = await getRestApi()
  return await restApi.get('gato-api-function/ObtenerEmpresasUsuarioB2c', {
    params: {guid},
  })
}
